module.exports = __webpack_public_path__ + "img/48.8.TSS.07b4c682.png";